import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import moment from "moment";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { EGiftVenue } from "src/app/shared/models/eGift/EGiftVenue.model";
import { OOMenuItem } from "src/app/shared/models/oo-menu-item";
import { OOVenue } from "src/app/shared/models/oo-venue";

@Component({
	selector: "app-e-gift-setup",
	templateUrl: "./e-gift-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class EGiftSetupComponent implements OnInit, OnDestroy {
	@Input() eGiftVenue: EGiftVenue;
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	emailLogoSrc: string;

	loaded: boolean = false;
	logoSrc: string;

	menuItemSubscription: Subscription = new Subscription();
	menuItemList: OOMenuItem[];
	moment: any = moment;

	ooVenue: OOVenue;

	timestamp: number;

	venueChangeSubscription: Subscription;

	constructor(public app: AppService, private focuslink: FocuslinkService, public imgCrop: ImageCropperService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.menuItemSubscription.add(
			this.venueService.subscriptionOOmenuItems.subscribe((mi) => {
				mi && mi.length > 0 && (this.menuItemList = mi);
			})
		);

		if (this.venueService.subscriptionOOmenuItems.value.length == 0) {
			this.venueService.menuItemsGet();
		}
		if (!this.eGiftVenue?.logoS3Key) {
			this.logoSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${this.venueService.subscriptionVenue.value.key}/logo.png`;
		} else {
			this.logoSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${this.venueService.subscriptionVenue.value.key}/${this.eGiftVenue.logoS3Key}`;
		}

		this.emailLogoSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${this.venueService.subscriptionVenue.value.key}/${
			this.eGiftVenue.emailLogoS3Key || this.eGiftVenue.logoS3Key || `logo.png`
		}`;
	}

	ngOnDestroy() {
		this.save();
	}

	async save() {
		await this.focuslink.eGiftVenuePost(this.venueService.subscriptionVenue.value.key, this.eGiftVenue);
	}

	async selectImage(source) {
		await this.save();
		this.imgCrop.openImageCropper(source, undefined, this.venueService.subscriptionVenue.value.key);
	}

	async onImageComplete(type: string) {
		await this.app.references.delay(1000);
		this.timestamp = moment().unix();
		if (type === "egiftLogo") {
			if (!this.eGiftVenue.logoS3Key) {
				this.eGiftVenue.logoS3Key = "egift-logo.png";
				this.logoSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${this.venueService.subscriptionVenue.value.key}/${this.eGiftVenue.logoS3Key}`;
			}
		}
		if (type === "egiftEmailLogo") {
			if (!this.eGiftVenue.emailLogoS3Key) {
				this.eGiftVenue.emailLogoS3Key = "egift-email-logo.png";
				this.emailLogoSrc = `https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/${this.venueService.subscriptionVenue.value.key}/${
					this.eGiftVenue.emailLogoS3Key || this.eGiftVenue.logoS3Key || `logo.png`
				}`;
			}
		}
	}
}
